module.exports = __webpack_public_path__ + "static/img/img-qywx.340d11c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-qywx.png
// module id = ITeC
// module chunks = 0